LiveForm.setOptions({
    showMessageClassOnParent: '(A-checkbox|A-textField|js-textField|M-fieldset)',
    messageParentClass: '(A-checkbox|A-textField|js-textField|M-fieldset)',
    controlErrorClass: '-hasError',
    controlValidClass: '-isValid',
    enableHiddenMessageClass: '-showHiddenMessage',
    messageErrorClass: 'A-textField__message',
    messageErrorPrefix: '',
    messageTag: 'div',
});

LiveForm.addError = function (el, message) {
    // Ignore elements with disabled live validation
    if (this.hasClass(el, this.options.disableLiveValidationClass)) {
        return;
    }

    this.setFormProperty(el.form, 'hasError', true);
    this.addClass(this.getGroupElement(el), this.options.controlErrorClass);

    if (this.options.showValid && this.showValid(el)) {
        this.removeClass(this.getGroupElement(el), this.options.controlValidClass);
    }

    if (!message) {
        message = '&nbsp;';
    } else {
        message = this.options.messageErrorPrefix + message;
    }

    const messageEl = this.getMessageElement(el);
    messageEl.innerHTML = message;
    messageEl.className = this.getMessageErrorClass(el);
};

LiveForm.removeError = function (el) {
    // We don't want to remove any errors during onLoadValidation
    if (this.getFormProperty(el.form, 'onLoadValidation')) {
        return;
    }

    // Dont touch group error label if attr exist.
    // Example for autocomplete select plugin input
    const dontRemoveGroupErrorLabel = el.getAttribute('data-lfv-dont-remove-group-error-label');
    const groupEl = this.getGroupElement(el);
    if (!dontRemoveGroupErrorLabel) {
        this.removeClass(groupEl, this.options.controlErrorClass);
    }

    const id = el.getAttribute('data-lfv-message-id');
    if (id) {
        const messageEl = this.getMessageElement(el);
        messageEl.innerHTML = '';
        messageEl.className = '';
    }

    if (this.options.showValid && this.showValid(el)) {
        this.addClass(groupEl, this.options.controlValidClass);
    }
};

LiveForm.getMessageErrorClass = function (el) {
    let messageErrorClass = this.options.messageErrorClass;
    if (this.hasClass(el, 'A-radio__input')) {
        messageErrorClass = 'M-fieldset__message';
    } else if (this.hasClass(el, 'A-checkbox__input')) {
        messageErrorClass = 'A-checkbox__message';
    } else if (this.hasClass(el, 'A-inputFile__formElement')) {
        messageErrorClass = 'A-inputFile__message';
    }

    return messageErrorClass;
};

LiveForm.processServerErrors = function (el) {
    const messageEl = this.getMessageElement(el);
    const parentEl = this.getMessageParent(el); // This is parent element which contain the error elements

    const errors = [];

    // Find existing error elements by class (from server-validation)
    const errorEls = parentEl.getElementsByClassName(this.getMessageErrorClass(el));
    for (let i = errorEls.length - 1; i > -1; i--) {
        // Don't touch our main message element
        if (errorEls[i] !== messageEl) {
            // Remove only direct children
            const errorParent = errorEls[i].parentNode;
            if (errorParent === parentEl) {
                errors.push(errorEls[i].outerHTML);
                errorParent.removeChild(errorEls[i]);
            }
        }
    }

    // Wrap all server errors into one element
    if (errors.length > 0) {
        messageEl.innerHTML = errors.join('');
    }
};
